export interface SwitchProps { [key: string]: boolean[] }
export interface HiddenItemProps { [key: string]: boolean }
export interface DBValueProps { switch_status: SwitchProps, nodes: HiddenItemProps, edges: HiddenItemProps };

class DB {
  private DB_NAME: string = 'workflow';
  private DB_VERSION: number = 1;
  private DB_STORE_NAME: string = 'hidden_or_show';
  public db: IDBDatabase | null = null;
  public value = 1;
  constructor() {}
  init () {
    let request = window.indexedDB.open(this.DB_NAME, this.DB_VERSION);
    return new Promise((resolve, reject) => {
      request.onerror = err => {
        resolve(false);
      }
      request.onsuccess = (res: any) => {
        this.db = res.target.result;
        resolve(true);
      }
      request.onupgradeneeded = (e: any) => {
        let store = e.currentTarget.result.createObjectStore(this.DB_STORE_NAME, { keyPath: 'workflow_id'});
        store.createIndex("workflow_id", "workflow_id", { unique: true });
      }
    })
  }
  add (payload: { value: DBValueProps, workflow_id: number }) {
    if (!this.db) return false;
    let store = this.db.transaction([this.DB_STORE_NAME], 'readwrite').objectStore(this.DB_STORE_NAME);
    let request = store.add({ map: payload.value, workflow_id: payload.workflow_id });
    return new Promise((resolve, reject) => {
      request.onsuccess = res => {
        resolve(true);
      }
      request.onerror = (err: any) => {
        console.log("err==>", err.target.error);
        resolve(false);
      }
    })
  }
  get (id: string | number) {
    if (!this.db) return null;
    let store = this.db.transaction([this.DB_STORE_NAME]).objectStore(this.DB_STORE_NAME);
    let request = store.get(id);
    return new Promise((resolve, reject) => {
      request.onsuccess = (res: any) => {
        if (res.target.result) {
          console.log("获取成功", res.target.result);
          resolve(res.target.result.map as DBValueProps);
        } else {
          console.log("未获取到数据")
          resolve(null)
        }
      }
      request.onerror = err => {
        console.log("数据获取失败", err);
        resolve(null)
      }
    })
  }
  update (id: number, value: DBValueProps) {
    if (!this.db) return false;
    let store = this.db.transaction([this.DB_STORE_NAME], 'readwrite').objectStore(this.DB_STORE_NAME);
    let request = store.put({ workflow_id: id, map: value })
    return new Promise((resolve, reject) => {
      request.onsuccess = (res: any) => {
        console.log("更新成功")
        resolve(true);
      }
      request.onerror = (err: any) => {
        console.log("更新失败", err.target.error);
        resolve(false);
      }
    })
    
  }
}

export default DB;
